import _ from "lodash"

/**
 * Apply formatting function to values.
 *
 * @returns {string}
 */
function applyPlotOptionsPlugin(plotOptions) {
  _.set(plotOptions, "series.compare", "value")
}

/**
 * Custom highcharts plot options
 * See API doc: https://api.highcharts.com/highstock/plotOptions
 * @param chartOpts
 * @returns {*}
 */
export default function montaignePlotOptionsPlugin(chartOpts) {
  if (!chartOpts.plotOptions) {
    return chartOpts
  }

  if (_.isArray(chartOpts.plotOptions)) {
    chartOpts.plotOptions.forEach(applyPlotOptionsPlugin)
    return chartOpts
  }
  applyPlotOptionsPlugin(chartOpts.plotOptions)
  return chartOpts
}
